import {
	Claim as ClaimFragment,
	DetailedClaim as DetailedClaimFragment,
	DetailedPolicy as DetailedPolicyFragment
} from "./fragments"

const createClaim = `
mutation createClaim ($createClaimInput: createClaimInput!) {
  createClaim(input: $createClaimInput) {
    createdStatus {
      id
    }
    errors
    status
  }
}`

const addBenefitToClaim = `
mutation addBenefitToClaim($claimId: ID! $input: addBenefitToClaimInput!) {
  addBenefitToClaim(claimId: $claimId input: $input) {
    errors
    errors_2 {
      code message
    }
    status
  }
}`

const removeBenefitFromClaim = `
mutation removeBenefitFromClaim($claimId: ID! $benefitClaimId: String!) {
  removeBenefitFromClaim(claimId: $claimId benefitClaimId: $benefitClaimId) {
    errors
    errors_2 {
      code message
    }
    status
  }
}`

const updateBenefitClaim = `
mutation updateBenefitClaim($claimId: ID! $benefitClaimId:String! $input: updateBenefitClaimInput!) {
  updateBenefitClaim(claimId: $claimId benefitClaimId: $benefitClaimId input: $input) {
    errors
    errors_2 {
      code message
    }
    status
  }
}`

const updateClaimFact = `
mutation updateClaimFact($claimId: ID! $factId: String! $input: updateFactInput!) {
  updateClaimFact(claimId: $claimId factId:$factId input: $input) {
    errors
    errors_2 {
      code message
    }
    status
  }
}`

const removeFactFromClaim = `
mutation removeFactFromClaim($claimId: ID! $factId: String!) {
  removeFactFromClaim(claimId: $claimId factId: $factId) {
    errors
    errors_2 {
      code message
    }
    status
  }
}
`

const updateClaim = `
mutation updateClaim ($claimId: ID! $input: updateClaimInput!) {
  updateClaim(claimId:$claimId input:$input){
    errors
    errors_2 {
      code
      message
    }
    status
  }
}
`

const deleteClaim = `
mutation deleteClaim ($claimId: ID!) {
  deleteClaim(claimId:$claimId){
    errors
    errors_2 {
      code
      message
    }
    status
  }
}
`

const listClaims = `
${ClaimFragment}
query listClaims($limit: Int $skip: Int $sort: sortInput $where: claimWhereInput) {
  claims(limit: $limit, skip: $skip, where: $where, sort: $sort) {
    list {
      id
      ...Claim
    }
    totalCount
  }
}`

const claim = `
${DetailedClaimFragment}
query claim($limit: Int $where: claimWhereInput) {
  claims(limit: $limit where: $where) {
    list {
      id
      ...DetailedClaim
    }
  }
}`

const findPolicy = `
query findPolicy($limit: Int, $skip: Int, $where: policyWhereInput) {
  policies(limit: $limit, skip: $skip, where: $where) {
    totalCount
    list {
      id
      issuerNumber
      acceptedOffer{
        product{
          productId{
            plan
            type
            version
          }
        }
      }
      holder {
        ...on individual { name }
        ...on company { name }
      }
    }
  }
}`

const findPolicyDetails = `
${DetailedPolicyFragment}
query findPolicyDetails($limit: Int, $where: policyWhereInput) {
  policies(limit: $limit, where: $where) {
    list {
      issuerNumber
      ...DetailedPolicy
    }
  }
}`

const pdfTemplates = `
				query fetchTemplates {
					templates {
						totalCount
						list {
							id
							name
							createdAt
							lastModifiedAt
							__typename
							graphQlQuery
						}
					}
				}
      `

const pdfDrawingQuery = `
				query renderPdfDrawingTemplate(
					$templateId: String!
					$input: templateRenderParametersInput
				) {
					renderPdfDrawingTemplate(templateId: $templateId, input: $input) {
						errors
						status
						value
					}
				}
			`

const wkhtmltopdfQuery = `
				query renderWkhtmltopdfTemplate(
					$templateId: String!
					$input: templateRenderParametersInput
				) {
					renderWkhtmltopdfTemplate(templateId: $templateId, input: $input) {
						errors
						status
						value
					}
				}
			`

const factsTemplates = `
query claimFactTemplates($ids:[String]){
  claimFactTemplates (ids:$ids){
    id
    name
    possibleValueTemplates {
      factName
      factType
      possibleValues {
        scalarType
        values {
          stringValue
          numberValue
          booleanValue
          dateValue
        }
      }
    }
  }
}`

const benefitClaimsAndBalance = `
query benefitClaims($where: claimWhereInput) {
  claims(where: $where) {
    list {
      id
      claimBalance{
        typeId
        name
        formattedValue: value
        value: value2{
          objectValue{
            key
            value{
              numberValue
            }
          }
        }
      }
      benefitClaims{
        benefit{
          typeId
          parentTypeId
        }
        id
        benefitName
        values {
          approvedAmount
          approvedCurrency
          billedAmount
          billedCurrency
          unit
        }
        totalValues {
          approvedAmount
          approvedCurrency
          billedAmount
          billedCurrency
          unit
          formattedApprovedAmount
          formattedBilledAmount
        }
        remark
      }
    }
  }
}`

const benefitGraph = `
query claimBalance($where: claimWhereInput) {
  claims(where: $where) {
    list {
      id
      policy{
        acceptedOffer{
          product{
            benefitGraph{
              name
              typeId
              children{
                name
                typeId
                children{
                  name
                  typeId
                  children{
                    name
                    typeId
                    children{
                      name
                      typeId
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`

const claimSummary = `
query claimSummary($where: claimWhereInput) {
  claims(where: $where) {
    list {
      id
      totalValues {
        formattedApprovedAmount
        formattedBilledAmount
      }
    }
  }
}`

const addFactToClaim = `
mutation addFactToClaim($claimId: ID! $input: addFactInput!) {
  addFactToClaim(claimId: $claimId input: $input) {
    errors
    status
  }
}`

const claimLogs = `
query claims($where: claimWhereInput $skip: Int $limit: Int $sort: sortInput){
  claims(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      events{
        timestamp
        by{
          username
        }
        type
      }
    }
  }
}
`

const claimTransactions = `
query claims($where: claimWhereInput $skip: Int $limit: Int $sort: sortInput){
  claims(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      transactions{
        id
        formattedTransaction
        currencyCode
        dateTime
        amount
        status
        method
        transactionNumber
      }
    }
  }
}
`

const addTransaction = `
mutation addTransaction($input: createTransactionInput!){
  createTransaction(input: $input){
    status
    errors
  }
}`

const updateTransaction = `
mutation updateTransaction($transactionId: String! $input: updateTransactionInput!){
  updateTransaction(transactionId: $transactionId input: $input){
    status
    errors
  }
}`

const claimFiles = `
query claimFiles($prefix:String) {
  fileListing(prefix:$prefix){
    commonPrefixes
    objectSummaries {
      key
      size
      lastModifiedAt
    }
  }
}
`

const claimRejectionSettings = `
query claimsRejectionSettings($where: policyWhereInput){
  policies(where:$where){
    list{
      acceptedOffer {
        product {
          claimSettings{
            rejectionSettings {
              codeNames {
                code
                name
              }
            }
          }
        }
      }
    }
  }
}
`

const rejectClaim = `
mutation rejectClaim($claimId: ID! $codes: [String] $remarks: String) {
  rejectClaim(claimId: $claimId codes: $codes remarks: $remarks){
    status
  }
}
`

const generalCodes = `
query generalCodes($where:productWhereInput $hasOperationSettings:Boolean = false $hasDiagnosisSettings:Boolean = false $hasProviderSettings:Boolean = false){
	products: products_2(where:$where){
    list{
      claimSettings{
        operationSettings @include(if: $hasOperationSettings){
        	codeNames{
            code
            description
            name
          }
        }
        diagnosisSettings @include(if: $hasDiagnosisSettings){
        	codeNames{
            code
            description
            name
          }
        }
        providerSettings @include(if: $hasProviderSettings){
        	providers{
            id
            name
            internalCode
          }
        }
      }
    }
  }
}
`

const query = {
	claim,
	findPolicy,
	findPolicyDetails,
	listClaims,
	pdfTemplates,
	wkhtmltopdfQuery,
	pdfDrawingQuery,
	factsTemplates,
	claimLogs,
	claimTransactions,
	claimFiles,
	claimRejectionSettings,
	generalCodes,
	benefitClaimsAndBalance,
	claimSummary,
	benefitGraph
}

const mutation = {
	createClaim,
	updateClaim,
	deleteClaim,
	addBenefitToClaim,
	removeBenefitFromClaim,
	updateBenefitClaim,
	addFactToClaim,
	updateClaimFact,
	removeFactFromClaim,
	addTransaction,
	updateTransaction,
	rejectClaim
}

export { query, mutation }
